module.exports = __webpack_public_path__ + "static/event_img2@2x-60ef23475097434e7ec978241231a834.png";